export function getRawInitData() {
  try {
    const raw = window?.Telegram?.WebApp?.initData;
    if (raw) return raw;
  } catch (e) {}
  return "";
}

export function getTelegramUser() {
  try {
    const u = window?.Telegram?.WebApp?.initDataUnsafe?.user;
    if (u?.first_name) return u;
  } catch (e) {}
  return { first_name: "Олексій", id: 348219044 };
}

const TG_BOT_USERNAME = "JoTrade_Pro_bot";

export function buildTelegramLinkUrl(otp) {
  return `https://t.me/${TG_BOT_USERNAME}?start=${otp || ""}`;
}